import { createAction } from '@reduxjs/toolkit';

const prefix = 'electron';

export const electronActions = {
  connected: createAction<{ connected: boolean }>(`${prefix}/connected`),
  makeCall: createAction<{ phoneNumber: string }>(`${prefix}/makeCall`),
  composeEmail: createAction<{ mailto: string }>(`${prefix}/composeEmail`),
  clearEventCache: createAction(`${prefix}/clearEventCache`),
};
